<template>
  <div>
    <el-table
      :data="tableData"
      style="width: 100%"
      border
    >
      <el-table-column
        prop="id"
        label="卡组ID"
        align="center"
      />
      <el-table-column
        prop="card1"
        label="卡组1"
        align="center"
      />
      <el-table-column
        prop="card2"
        label="卡组2"
        align="center"
      />
      <el-table-column
        prop="card3"
        label="卡组3"
        align="center"
      />
      <el-table-column
        prop="card4"
        label="卡组4"
        align="center"
      />
      <el-table-column
        prop="card5"
        label="卡组5"
        align="center"
      />
      <el-table-column
        prop="card6"
        label="卡组6"
        align="center"
      />
      <el-table-column
        prop="card7"
        label="卡组7"
        align="center"
      />
      <el-table-column
        prop="card8"
        label="卡组8"
        align="center"
      />
      <el-table-column
        prop="card9"
        label="卡组9"
        align="center"
      />
    </el-table>
  </div>
</template>
<script>

export default {
  name: 'UserCardInfo',
  data() {
    return {
      tableData: []
    }
  },
  created() {
    this.tableField = this.tableFieldArr['beast']
  },
  methods: {
    init(data) {
      this.tableData = []
      if (data.userCardGroup.length > 0) {
        const g = data.userCardGroup
        g.forEach(item => {
          const temp = {
            id: `${item.gid}-${item.g_name}`,
            card1: 0,
            card2: 0,
            card3: 0,
            card4: 0,
            card5: 0,
            card6: 0,
            card7: 0,
            card8: 0,
            card9: 0
          }

          let index = 0
          for (const i in item.card_info) {
            index++
            temp['card' + index] = `${item.card_info_name[i]}*${item.card_info[i]}`
          }

          this.tableData.push(temp)
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
